export const idlFactory = ({ IDL }) => {
  const Result = IDL.Variant({ Ok: IDL.Bool, Err: IDL.Text })
  const EVMChain = IDL.Record({
    id: IDL.Nat64,
    logo: IDL.Text,
    name: IDL.Text,
    fee_token_id: IDL.Opt(IDL.Text),
    rpc_provider: IDL.Text,
    rpc_endpoint: IDL.Text,
    rpc_url: IDL.Text,
    symbol: IDL.Text,
  })
  const Link = IDL.Record({
    id: IDL.Nat64,
    title: IDL.Text,
    chain: IDL.Opt(IDL.Text),
    kind: IDL.Text,
    link: IDL.Text,
    description: IDL.Opt(IDL.Text),
    image: IDL.Text,
  })
  const TokenDetail = IDL.Record({ value: IDL.Text, kind: IDL.Text })
  const NFT = IDL.Record({
    id: IDL.Text,
    chain: IDL.Text,
    name: IDL.Text,
    description: IDL.Text,
    links: IDL.Vec(TokenDetail),
    logo_url: IDL.Text,
    address: IDL.Text,
    additional_data: IDL.Vec(TokenDetail),
    standard: IDL.Text,
  })
  const AnalyticsDetails = IDL.Record({
    analytics_id: IDL.Opt(IDL.Text),
    price_provider: IDL.Opt(IDL.Text),
    analytics_provider: IDL.Opt(IDL.Text),
    price_id: IDL.Opt(IDL.Text),
  })
  const Token = IDL.Record({
    id: IDL.Text,
    fee: IDL.Opt(IDL.Nat),
    evm_chain_id: IDL.Opt(IDL.Nat64),
    decimals: IDL.Nat8,
    chain: IDL.Text,
    name: IDL.Text,
    tags: IDL.Vec(IDL.Text),
    sort_order: IDL.Nat64,
    fee_token_id: IDL.Opt(IDL.Text),
    description: IDL.Text,
    analytics_details: AnalyticsDetails,
    links: IDL.Vec(TokenDetail),
    logo_url: IDL.Text,
    group_id: IDL.Opt(IDL.Text),
    address: IDL.Opt(IDL.Text),
    additional_data: IDL.Vec(TokenDetail),
    standard: IDL.Text,
    symbol: IDL.Text,
  })
  const TokenGroup = IDL.Record({
    id: IDL.Text,
    name: IDL.Text,
    analytics_details: AnalyticsDetails,
    logo_url: IDL.Text,
    symbol: IDL.Text,
  })
  return IDL.Service({
    bulk_insert: IDL.Func([IDL.Text], [Result], []),
    bulk_insert_nfts: IDL.Func([IDL.Text], [Result], []),
    bulk_update: IDL.Func([IDL.Text], [Result], []),
    delete_evm_chain: IDL.Func([IDL.Nat64], [Result], []),
    delete_link: IDL.Func([IDL.Nat64], [Result], []),
    delete_nft: IDL.Func([IDL.Text], [Result], []),
    delete_token: IDL.Func([IDL.Text], [Result], []),
    delete_token_group: IDL.Func([IDL.Text], [Result], []),
    get_all_evm_chains: IDL.Func([IDL.Opt(IDL.Text)], [IDL.Vec(EVMChain)], ['query']),
    get_all_links: IDL.Func([], [IDL.Vec(Link)], ['query']),
    get_all_nfts: IDL.Func([], [IDL.Vec(NFT)], ['query']),
    get_all_tokens: IDL.Func([], [IDL.Vec(Token)], ['query']),
    get_token_groups: IDL.Func([], [IDL.Vec(TokenGroup)], ['query']),
    insert_admin: IDL.Func([IDL.Principal], [Result], []),
    insert_evm_chain: IDL.Func([EVMChain], [Result], []),
    insert_link: IDL.Func([Link], [Result], []),
    insert_nft: IDL.Func([NFT], [Result], []),
    insert_token: IDL.Func([Token], [Result], []),
    insert_token_group: IDL.Func([TokenGroup], [Result], []),
    update_evm_chain: IDL.Func([EVMChain], [Result], []),
    update_link: IDL.Func([Link], [Result], []),
    update_nft: IDL.Func([NFT], [Result], []),
    update_token: IDL.Func([Token], [Result], []),
    update_token_group: IDL.Func([TokenGroup], [Result], []),
  })
}
export const init = ({ IDL }) => {
  return []
}
